import { ProjectService } from '@alpha-core/platform-ui';
import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ImageDisplayDirective } from '../../../pipes/image-display.directive';

@Component({
    selector: 'app-loader',
    standalone: true,
    template: `<img
        class="max-h-15"
        [src]="loaderUrl | async"
        alphaImageDisplay="assets/images/loader-gif-image.gif"
        alt="loader"
    />`,
    imports: [AsyncPipe, ImageDisplayDirective],
})
export class LoaderComponent {
    loaderUrl = inject(ProjectService).fetchLoader(true);
}
